module.exports = __webpack_public_path__ + "static/media/home_bg.a2853462.svg";